import styled from 'styled-components';
import { View, Box } from './ui';
import type { CSSProperties } from 'react';
import React from 'react';

const defaultBg = '#fafbfc';

export const PageWrap = styled(View)`
  flex-grow: 1;
  min-height: calc(100vh - 48px);
  align-items: stretch;
  background-color: ${(props) =>
    props.theme?.colors?.neutral.white_100 ?? defaultBg};
`;

export const BodyWrap = ({
  children,
  userSelect = 'auto',
}: {
  children: React.ReactNode;
  userSelect?: CSSProperties['userSelect'];
}) => {
  return (
    <Box
      display="flex"
      flexDirection="column"
      overflow="hidden"
      style={{
        height: 'calc(100vh - 48px)',
        userSelect,
      }}
    >
      {children}
    </Box>
  );
};

BodyWrap.displayName = 'BodyWrap';
PageWrap.displayName = 'PageWrap';
